import React from 'react';

export function LogoSmilesSmallImage() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M23.9635 9.51047C24.1157 9.19771 23.7606 8.86337 23.4765 9.0575C22.117 9.99579 18.4544 12.0018 12.0018 12.0018C5.54913 12.0018 1.88655 9.99579 0.527031 9.0575C0.242952 8.86337 -0.122291 9.19771 0.0400392 9.51047C1.00388 11.4625 5.64044 15 11.9916 15C18.3428 15 22.9794 11.4518 23.9432 9.51047H23.9635Z"
        fill="#FF7020"
      />
    </svg>
  );
}
